// ─── Fase 15-16 · Bloque 4 — Session-scoped hint toasts ─────────────────
// Wraps `sonner.toast` so each named hint fires at most ONCE per page load.
// (Module-level Set, cleared only on full reload.)
//
// Fase 17 · Bloque 1 — HOTFIX: hardened so a malformed action object can NEVER
// bring down the app. We sanitize inputs and wrap the toast call in try/catch.
import { toast } from "sonner";

const fired = new Set();

function sanitizeAction(action) {
  if (!action) return undefined;
  // Sonner v2 expects `{ label: ReactNode, onClick: (e) => void }`.
  // If we got something else (a raw string, a missing onClick, etc.), drop it
  // so it never crashes the renderer.
  if (typeof action !== "object") return undefined;
  if (typeof action.onClick !== "function") return undefined;
  if (action.label == null) return undefined;
  return { label: action.label, onClick: action.onClick };
}

export function hint(name, opts = {}) {
  if (fired.has(name)) return;
  fired.add(name);
  try {
    const title = opts.title != null ? String(opts.title) : "";
    toast(title, {
      description: opts.description,
      duration: opts.duration ?? 6000,
      action: sanitizeAction(opts.action),
    });
  } catch (err) {
    // Last-resort guard: never let a toast take the app down.
    // eslint-disable-next-line no-console
    console.warn("[hint] toast failed:", name, err);
  }
}

export function resetHints() { fired.clear(); }
